import en_US from 'antd/lib/locale/en_US';
import es_ES from 'antd/lib/locale/es_ES';
import fr_FR from 'antd/lib/locale/fr_FR';
import zh_CN from 'antd/lib/locale/zh_CN';

export const localeMap = { en_US, es_ES, fr_FR, zh_CN };
